import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function initializeScrollAnimations() {

    ScrollTrigger.getAll().forEach(trigger => trigger.kill());

    const heroSliders = document.querySelectorAll(".scalling-section");
    const sliderContent = document.querySelectorAll(".section-hero-slider__content .container");
    const logo = document.getElementById("logo");

    if (heroSliders) {
        heroSliders.forEach((element, index) => {
            const z2 = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top top",
                    end: '+=50%',
                    scrub: true,
                    pin: true,
                    pinSpacing: true,
                }
            });

            let clipPathSize = window.innerWidth < 992 ? "circle(115px)" : "circle(210px)";

            z2.to(element, {
                clipPath: clipPathSize,
                duration: 1,
            });

            z2.to(sliderContent, {
                opacity: 0,
                duration: 0.5,
            }, 0);

            let timer;

            z2.to(logo, {
                opacity: 1,
                duration: 0.5,
                onUpdate: function () {
                    const progress = z2.progress(); // Odczytujemy postęp animacji
                    if (progress === 1) {
                        logo.querySelectorAll('.logo-slider__letter').forEach(letter => {
                            letter.classList.add('logo-slider__start');
                        });

                        timer = setInterval(() => {
                            logo.querySelectorAll('.logo-slider__letter').forEach(letter => {
                                letter.classList.toggle('logo-slider__start');
                            });
                        }, 2000);
                    } else {
                        clearInterval(timer);
                        logo.querySelectorAll('.logo-slider__letter').forEach(letter => {
                            letter.classList.remove('logo-slider__start');
                        });
                    }
                }
            }, 0.5);
        });
    }


    /* Hero radius */
    let heroTimeline;
    const heros = document.querySelectorAll(".section-hero");
    if (window.innerWidth >= 992 && heros) {
        heros.forEach((hero, index) => {
            const heroBg = hero.querySelector(".section-hero__overlay");
            const heroImg = hero.querySelector(".section-hero__overlay > div");
            heroTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: hero,
                    start: "top top",
                    end: "+=25%",
                    scrub: true,
                    pin: true,
                    pinSpacing: true,
                    //markers: true,
                }
            });

            /*heroTimeline.to(hero, {
                transform: "translateY(-40px)",
            });*/

            heroTimeline.to(heroBg, {
                padding: "20px",
            });

            heroTimeline.to(heroImg, {
                borderRadius: "24px",
            }, "-=0.5");
        });
    }

    /* Realization gsap */

    const sections = document.querySelectorAll(".overlapping-section");

    if (sections) {
        sections.forEach((element, index) => {
            const position = "top " + ((index * 35) + 65) + "px";

            const zzz = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: position,
                    endTrigger: sections[sections.length - 1],
                    end: "bottom bottom",
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                }
            });


            // Dodatkowa linia czasu dla animacji związanych ze skalowaniem i rozmywaniem
            const zu = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: position,
                    end: "bottom top",
                    scrub: true
                }
            });

            const blur = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: position,
                    end: "bottom top",
                    scrub: true
                }
            });

            // Skaluje i rozmywa sekcje na podstawie ich indeksu

            if (index < sections.length - 1) {
                zu.to(element, {
                    scale: 0.9 - (sections.length - (index + 1)) / 20
                });


                blur.to(element, {
                    "--overlappingBlur": "3px"
                }, 0.5);
            }
        });
    }



    /* */
    const sectionNumbers = document.querySelector(".section-numbers__list");
    const numbers = document.querySelectorAll(".numbers__single");

    if (sectionNumbers) {

        // Tworzymy główną linię czasu dla animacji przewijania
        const numberTimeline0 = gsap.timeline({
            scrollTrigger: {
                trigger: sectionNumbers, // Główny kontener z sekcjami nakładającymi się
                start: "top top", // Rozpocznij, gdy górna krawędź kontenera dotrze do górnej krawędzi okna przeglądarki
                end: "bottom bottom", // Zakończ, gdy dolna krawędź kontenera dotrze do dolnej krawędzi okna przeglądarki
                scrub: true, // Płynne przewijanie
                pin: false, // Przypnij kontener podczas przewijania
                pinSpacing: false,
                //markers: true,

            }
        });

        numbers.forEach((number, index) => {
            // Oblicz położenie startowe dla każdej sekcji na podstawie wysokości okna i indeksu
            const position = "top " + ((window.innerHeight - number.scrollHeight) / 2 + 40 * index) + "px";

            const scrollTriggerSettings = {
                trigger: number,
                start: "top 140px",
                end: "bottom 140px",
                scrub: true,
                pin: true,
                pinSpacing: false,
                //markers: true,
            };

            // Sprawdzenie szerokości ekranu
            if (window.innerWidth < 992) {
                scrollTriggerSettings.pin = false;
            }


            // Tworzymy linię czasu dla każdej sekcji
            gsap.timeline({
                scrollTrigger: scrollTriggerSettings
            });

            // Dodatkowa linia czasu dla animacji związanych ze skalowaniem i rozmywaniem
            if (window.innerWidth >= 992) {
                const numberTimeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: number,
                        start: "top 140px",
                        end: "bottom 140px",
                        scrub: true,
                        //markers: true,

                    }
                });

                if (index < numbers.length - 1) {
                    numberTimeline.to(number, {
                        opacity: 0,
                        transform: "translateY(-60px)"
                    });
                }
            }


            const description = number.querySelector('.numbers__description');

            const numberTimeline2 = gsap.timeline({
                scrollTrigger: {
                    trigger: number,
                    start: "-300px top",
                    end: "bottom 300px",
                    scrub: true,
                    //markers: true,

                }
            });

            numberTimeline2.to(description, {
                opacity: 1,
            });

            const h1 = number.querySelector('.numbers__h1');

            const numberTimeline3 = gsap.timeline({
                scrollTrigger: {
                    trigger: number,
                    start: "-300px top",
                    end: "bottom 300px",
                    scrub: true,

                }
            });

            numberTimeline3.to(h1, {
                color: "rgba(34, 34, 34, 1)",
            });
        });
    }

    /* */
    const industries = document.querySelector(".section-industries-slides__elements");

    if (industries) {
        gsap.timeline({
            scrollTrigger: {
                trigger: industries,
                start: "top top",
                scrub: true,
                pin: false,
                pinSpacing: false,

                onEnter: () => {
                    industries.classList.add("active");
                },
                onLeave: () => {
                    industries.classList.remove("active");
                },
                onEnterBack: () => {
                    industries.classList.add("active");
                },
                onLeaveBack: () => {
                    industries.classList.remove("active");
                },
            }
        });
    }

    /* Gsap for columns */
    const columns = document.querySelectorAll('.columns-gsap');

    if (columns) {
        columns.forEach((column) => {
            const elements = column.querySelectorAll('.column-gsap');
            elements.forEach((element, index) => {
                let delayTime = window.innerWidth > 768 ? index * 0.2 : 0;

                gsap.fromTo(element, {
                    opacity: 0,
                    y: 50,
                }, {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: delayTime,
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                    }
                });
            })
        });
    }

    const video = document.querySelector('#background-video');

    if (video) {
        gsap.timeline({
            scrollTrigger: {
                trigger: video,
                start: "top 100%",
                end: "bottom 0%",
                onEnter: () => video.play(),
                onLeave: () => video.pause(),
                onEnterBack: () => video.play(),
                onLeaveBack: () => video.pause(),
            }
        });
    }

    const parallax = document.querySelectorAll(".columns-image--column-big");

    if (window.innerWidth >= 992 && parallax) {
        parallax.forEach((element) => {
            const parallaxTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 100%",
                    end: 'bottom 0%',
                    scrub: true,
                    pin: false,
                    pinSpacing: true,
                }
            });

            let image = element.querySelector('img');

            parallaxTimeline.to(image, {
                transform: "translateY(250px)",
            });
        });
    }

    const items = document.querySelectorAll('.section-industries__element');
    const images = document.querySelectorAll('.section-industries__img');

    if (items) {
        items.forEach(item => {
            item.addEventListener('mouseenter', () => {
                items.forEach(el => el.classList.remove('section-industries__element--current'));
                item.classList.add('section-industries__element--current');

                images.forEach(el => el.classList.remove('section-industries__img--current'));
                let current = item.getAttribute('data-id');
                let currentImage = document.querySelector('.section-industries__img[data-id="' + current + '"]');
                currentImage.classList.add('section-industries__img--current');
            });
        });
    }


    //ScrollTrigger.refresh();
}
